export default __webpack_public_path__ + "static/1.2-Text-alternatives-DO-f4088e60df82f4d9584ea39a017fbee6.png";